import React, {PropTypes} from 'react'
import {connect} from 'react-redux'
import styles from './webapps.scss'
import nesProp from 'nested-property'

import i18n from 'lib/i18n'
const _ = i18n('webapps')

@connect(
    ({
        app: {lang, security: {WebAppTypes}}
    }) => ({
        lang,
        WebAppTypes
    }
))
export default class WebAppClickableThumbBlock extends React.Component {
	static propTypes = {
		webApp: PropTypes.object,
        img: PropTypes.string.isRequired,
	    desc: PropTypes.string.isRequired,
	    onSelect: PropTypes.func.isRequired
	}

    render() {
        const {webApp, img, desc} = this.props

        return <div className={styles.item}
            onClick={() => {
                return this.props.onSelect(webApp)
            }}
            key={"WebAppClickableThumbBlock" + webApp._id}
        >
            <div className={styles.imageContainer} key={"WebAppClickableThumbBlockImg" + webApp._id}>
                <img src={img}/>
            </div>
            <div className={styles.descContainer} key={"WebAppClickableThumbBlockDesc" + webApp._id}>
                <span>{desc}</span>
            </div>
	    </div>
    }
}



// WEBPACK FOOTER //
// ./components/webapps/WebAppClickableThumbBlock.jsx